import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=063ffb84"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports